<template>
  <ListItemWithIcon>
    <div slot="list-item-text">
      <strong :style="emphasisStyle">
        Le programme Andros se termine
      </strong>
      : il ne sera plus disponible sur le site
      <strong>androsvegetal.fr</strong> à partir du 30 septembre.
      Votre carte reste valable jusqu'à sa date d'expiration :
      rendez-vous sur l'application FidMarques pour retrouver vos points et
      autres programmes de fidélité.
    </div>
  </ListItemWithIcon>
</template>

<script>
import ListItemWithIcon from '~/components/elements/ListItemWithIcon'
export default {
  components: { ListItemWithIcon },
  props: {
    emphasisStyle: {
      type: [String, Object],
      required: true,
    },
  },
}
</script>
